// extracted by mini-css-extract-plugin
export default {"wrapper":"S2-z","play":"T2-z"};